export default {
      id: "pinterest-usage",
      viewBox: "0 0 21 20",
      url: "../dist/images/" + "sprite.svg#pinterest-usage",
      toString: function () {
        return this.url;
      }
    }